import { DataTableColumn } from "../../../../shared/components/data-table/DataTableColumn.model";

export interface OrganizationMember {
    memberId: string;
    memberIdText?: string;
    firstName: string;
    lastName: string;
    email: string;
    phoneNumber?: string;
    status: string;
    sendActivationLink: boolean;
    role: string;
}

export interface OrganizationLegacyMember {
    account_id: number;
    first_name: string;
    last_name: string;
    email_address: string;
    phone: string;
    status_id: number;
    roles: OrganizationLegacyMemberRole[];
}

export interface OrganizationLegacyMemberRole {
    role_id: number;
    name: string;
}

export const OrganizationMemberColumns: DataTableColumn[] = [
    { column: 'id', display: 'Account ID' },
    { column: 'firstName', display: 'First Name' },
    { column: 'lastName', display: 'Last Name' },
    { column: 'email', display: 'Email' },
    { column: 'phone', display: 'Phone' },
    { column: 'role', display: 'Role' },
    { column: 'pillStatus', display: 'Status' }
]